if (!customElements.get("footer-details")) {
  const FooterAccordionBase = typeof AccordionDetails === "undefined" ? HTMLDetailsElement : AccordionDetails;

  class FooterDetails extends FooterAccordionBase {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';
      const foxThemeConfig = window.FoxTheme?.config;
      if (!foxThemeConfig) return;

      if (foxThemeConfig.mqlTablet) {
        if (!this.openDefault) this.setOpen(false);
      }

      document.addEventListener('matchTablet', () => {
        this.setOpen(this.openDefault);
      });

      document.addEventListener('unmatchTablet', () => {
        this.setOpen(true);
      });
    }

    // The HTMLDetailsElement fallback base has no toggle(value).
    setOpen(value) {
      if (typeof this.toggle === 'function') {
        this.toggle(value);
      } else {
        this.open = value;
      }
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}
